import { memo } from 'react';
import { useTranslation } from 'next-i18next';
import { Wrapper, CheckboxGroup, SecondaryList } from '../../design-system';
import { Heading } from '@restworld/ui-ds-base';
import { ClipboardDocumentListIcon } from '@heroicons/react/24/outline';
import { SkillsPreviewData } from './types';
import { OtherRequirementsPreview } from './other-requirements-preview';

export const SkillsPreviewBlock = memo(
  ({
    requiredSkills = [],
    optionalSkills = [],
    otherRequirements = [],
    education = [],
    certificates = [],
    languages = [],
  }: SkillsPreviewData) => {
    const { t } = useTranslation('common');

    return (
      <Wrapper>
        <span className="flex items-center gap-1">
          <ClipboardDocumentListIcon className="h-6 w-6" />
          <Heading size={4} weight="semibold">
            {t('job_position_preview_skills_title')}
          </Heading>
        </span>

        {/* Required Skills */}
        {requiredSkills?.length > 0 && <CheckboxGroup options={requiredSkills} value={[]} isWrapList />}

        {/* Optional Skills */}
        {optionalSkills?.length > 0 && (
          <SecondaryList
            itemList={optionalSkills.map((v) => ({
              key: v,
              label: v,
              icon: 'ClipboardDocumentCheckIcon',
            }))}
            orientation="vertical"
            textColor="gray"
            isWrapList
            fontSize="base"
          />
        )}

        {/* Other Requirements */}
        <OtherRequirementsPreview
          otherRequirements={otherRequirements}
          education={education}
          certificates={certificates}
          languages={languages}
        />
      </Wrapper>
    );
  }
);

SkillsPreviewBlock.displayName = 'SkillsPreviewBlock';
